import { env } from './env';

/**
 * Which surface this portal talks to.
 *
 * The server mounts five, and a token is only valid for its own - so pointing
 * this at another surface would fail with 403 rather than silently working.
 */
export const API = {
  baseUrl: env.apiBaseUrl,
  surface: '/api/user',
  timeoutMs: 20_000,

  endpoints: {
    login: '/auth/login',
    refresh: '/auth/refresh',
    logout: '/auth/logout',
    me: '/auth/me',
    sessions: '/auth/sessions',
    revokeOtherSessions: '/auth/sessions/revoke-others',

    // Self-service reset from the sign-in screen: mail a code, trade the code
    // for a reset token, spend the token on a new password. All anonymous.
    passwordResetRequest: '/auth/password-reset/request',
    passwordResetVerify: '/auth/password-reset/verify',
    passwordResetComplete: '/auth/password-reset/complete',

    // Second factor. `mfaVerify` completes a login and so takes no session;
    // the rest manage the factor for somebody already signed in.
    mfaVerify: '/auth/mfa/verify',
    mfa: '/auth/mfa',
    mfaEnroll: '/auth/mfa/enroll',
    mfaEnrollConfirm: '/auth/mfa/enroll/confirm',
    mfaDisable: '/auth/mfa/disable',
    issues: '/issues',
    // Who the caller may file for: an owner's licence group, or just themselves.
    issueReporters: '/issues/reporters',
    issue: (id: string) => `/issues/${id}`,

    licence: '/licence',
    // The caller's own switches: key-reveal password check and email preferences.
    settings: '/settings',
    // Re-checks the password, returns the caller's own key, and logs it.
    licenceRevealKey: '/licence/reveal-key',

    // The build the lab can install, and minting a link to fetch it. The
    // installer's own URL is never returned by the API - see
    // server/src/api/user/software.routes.ts.
    softwareLatest: '/software/latest',
    softwareDownloads: '/software/downloads',
  },
} as const;

export const apiUrl = (path: string): string => `${API.baseUrl}${API.surface}${path}`;
